import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Spinner } from 'react-activity';
import AdminHeaders from './Header';
import AdminNavigationBar from './Navigation';
import Loader from '../common/Loader';
import { myLog } from '../../../utils/Utility';
import { PATH } from '../../../utils/Constants';
import { showNotification } from './../../action/NotificationAction';
import {
    BRANCH_ADMIN_ROUTES_SECONDARY_PATH,
    INS_SUPER_ADMIN_ROUTES_SECONDARY_PATH,
    LEVEL_ONE_ADMIN_ROUTES_SECONDARY_PATH,
    LEVEL_TWO_ADMIN_ROUTES_SECONDARY_PATH,
} from '../../../utils/routes/path';
import { changePassword } from '../../../voim/action/UserAction';
import { RESPONSE_CONSTANT } from '../../../utils/ResponseConstant';

export class ChangePassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            newpassword: '',
            retypepassword: '',
            errormsg: '',
            isdisable: false,
            eightCharacter: false,
            oneUppercase: false,
            oneLowercase: false,
            oneNumberic: false,
            specialCharacter: false,
            ispasswordStrGood: false,
            passwordShown: false,
            retypePasswordShown: false,
            btnLoading: false,
        };
    }

    /**
     * @inheritDoc
     */
    componentDidMount() {
        this.resetValidation();
    }

    /**
     * Reset validation
     */
    resetValidation() {
        this.setState({
            eightCharacter: false,
            oneUppercase: false,
            oneLowercase: false,
            oneNumberic: false,
            specialCharacter: false,
        });
    }

    /**
     * Handle check password Strength
     * @param {*} value
     */
    CheckPasswordStrength(value) {
        if (value.toString().length >= 8) {
            this.setState({
                eightCharacter: true,
            });
        }
        let numUpper = value.length - value.replace(/[A-Z]/g, '').length;
        myLog('numUpper', numUpper);
        if (numUpper > 0) {
            this.setState({
                oneUppercase: true,
            });
        }
        let numLower = value.length - value.replace(/[a-z]/g, '').length;
        myLog('numUpper', numUpper);
        if (numLower > 0) {
            this.setState({
                oneLowercase: true,
            });
        }
        let numeric = value.length - value.replace(/[0-9]/g, '').length;
        myLog('numUpper', numUpper);
        if (numeric > 0) {
            this.setState({
                oneNumberic: true,
            });
        }
        let specialCharacter =
            value.length - value.replace(/[[ !@#$%^&*()_+\-=\\[\]{};':"\\|,.<>\\/?]/g, '').length;
        myLog('numUpper', numUpper);
        if (specialCharacter > 0) {
            this.setState({
                specialCharacter: true,
            });
        }
        if (
            value.length >= 8 &&
            numUpper > 0 &&
            numLower > 0 &&
            numeric > 0 &&
            specialCharacter > 0
        ) {
            this.setState({
                ispasswordStrGood: true,
            });
        }
    }

    /**
     * Handle change password
     */
    handleClick = () => {
        if (!this.state.newpassword) {
            this.setState({
                errormsg: 'Enter the New Password',
            });
            return;
        }
        if (!this.state.retypepassword) {
            this.setState({
                errormsg: 'Enter the Confirm Password',
            });
            return;
        }
        if (this.state.newpassword !== this.state.retypepassword) {
            this.setState({
                errormsg: 'Passwords does not match',
            });
            return;
        }
        this.Loading();
        let values = {
            password: this.state.newpassword,
        };
        this.setState({ btnLoading: true });
        this.props.changePassword(values, (result) => {
            this.setState({ btnLoading: false });
            this.Loading();
            if (result) {
                myLog('======registerPhysician::::::::', result);

                if (result.code !== 200) {
                    this.props.showNotification(result.validationErrors[0], 'error');
                    return;
                }
                if (result.code === 200) {
                    this.props.showNotification(result.message, 'success');
                    myLog(result.response);

                    if (result.response.role === RESPONSE_CONSTANT.BRANCHADMIN) {
                        this.props.history.push(
                            `${BRANCH_ADMIN_ROUTES_SECONDARY_PATH.BRANCH_ADMIN}/${result.response.id}${BRANCH_ADMIN_ROUTES_SECONDARY_PATH.DASHBOARD}`
                        );
                        this.resetValidation();
                    } else if (result.response.role === RESPONSE_CONSTANT.LEVEL_ONE_ADMIN) {
                        this.props.history.push(
                            `${LEVEL_ONE_ADMIN_ROUTES_SECONDARY_PATH.LEVEL_ONE_ADMIN}/${result.response.id}${LEVEL_ONE_ADMIN_ROUTES_SECONDARY_PATH.DASHBOARD}`
                        );
                        this.resetValidation();
                    } else if (result.response.role === RESPONSE_CONSTANT.LEVEL_TWO_ADMIN) {
                        this.props.history.push(
                            `${LEVEL_TWO_ADMIN_ROUTES_SECONDARY_PATH.LEVEL_TWO_ADMIN}/${result.response.id}${LEVEL_TWO_ADMIN_ROUTES_SECONDARY_PATH.DASHBOARD}`
                        );
                        this.resetValidation();
                    } else if (result.response.role === RESPONSE_CONSTANT.INSADMIN) {
                        this.props.history.push(
                            `${INS_SUPER_ADMIN_ROUTES_SECONDARY_PATH.INS_SUPER_ADMIN}/${result.response.id}${INS_SUPER_ADMIN_ROUTES_SECONDARY_PATH.DASHBOARD}`
                        );
                        this.resetValidation();
                    }
                } else {
                    this.props.showNotification('Something Went Wrong. try again...', 'error');
                }
            }
        });
    };

    /**
     * handle toggle loader
     */
    Loading() {
        this.setState({ isdisable: !this.state.isdisable });
    }
    togglePasswordVisibility = () => {
        this.setState((prevState) => ({
            passwordShown: !prevState.passwordShown,
        }));
    };
    toggleRetypePasswordVisibility = () => {
        this.setState((prevState) => ({
            retypePasswordShown: !prevState.retypePasswordShown,
        }));
    };

    render() {
        const { passwordShown, retypePasswordShown } = this.state;
        return (
            <div className="flex w-full h-full fixed left-0 top-0">
                <div
                    className={`bg-black bg-opacity-50 fixed top-0 left-0 w-full h-full z-10 ${
                        this.state.mobileNav ? 'block' : 'hidden'
                    }`}
                ></div>
                <AdminNavigationBar
                    nav={false}
                    {...this.props}
                    active={PATH.IM_PHYSICIAN.DASHBOARD}
                    mobileNav={this.state.mobileNav}
                    onClickMobileNav={this.onClickMobileNav}
                />
                <main className="flex flex-grow flex-col">
                    <AdminHeaders
                        {...this.props}
                        title="Change Password"
                        onClickMobileNav={this.onClickMobileNav}
                    />
                    <div className="h-full w-full flex-col flex overflow-auto py-8 bg-neutral">
                        <div className="sm:flex justify-between sm:px-8 px-4 items-center">
                            <h6 className="m-0 text-lg text-black font-semibold">
                                Change Password
                            </h6>
                        </div>
                        {this.state.isLoading ? (
                            <Loader />
                        ) : (
                            <div className="flex flex-row flex-grow sm:px-8 px-4 mt-6">
                                <div className="w-full flex flex-col p-6 border-black-10 bg-white rounded-lg">
                                    <label className="text-red">
                                        Allowed special characters(!,$,%,&,*,_,@)
                                    </label>
                                    <br />
                                    {this.state.errormsg !== '' ? (
                                        <span className="" style={{ color: 'red' }}>
                                            {this.state.errormsg}
                                        </span>
                                    ) : null}
                                    <div className="grid grid-cols-12 gap-x-6">
                                        <div className="sm:col-span-6 col-span-12">
                                            <div className="grid sm:grid-cols-1">
                                                <label
                                                    htmlFor="select-subject"
                                                    className="block mb-2 text-base font-normal text-black after:content-['*'] after:ml-0.5 after:text-red"
                                                >
                                                    New Password
                                                </label>
                                                <div className="flex border-black-10 w-full rounded mb-2">
                                                    <div className="grow">
                                                        <input
                                                            type={
                                                                passwordShown ? 'text' : 'password'
                                                            }
                                                            id="newpassword"
                                                            name="newpassword"
                                                            value={this.state.newpassword}
                                                            onChange={(evt) => {
                                                                this.resetValidation();
                                                                this.CheckPasswordStrength(
                                                                    evt.target.value
                                                                );
                                                                this.setState({
                                                                    errormsg: '',
                                                                    newpassword: evt.target.value,
                                                                });
                                                            }}
                                                            className="w-full py-1.5 text-black placeholder:text-secondary text-base px-2 rounded"
                                                            placeholder="New Password"
                                                            autoComplete="off"
                                                            onKeyPress={(evt) => {
                                                                if (evt.key === ' ') {
                                                                    evt.preventDefault();
                                                                }
                                                            }}
                                                            maxLength={64}
                                                        />
                                                    </div>
                                                    <div className="flex items-center px-3">
                                                        {passwordShown ? (
                                                            <i
                                                                className="fa-regular fa-eye text-sm text-secondary"
                                                                onClick={
                                                                    this.togglePasswordVisibility
                                                                }
                                                                style={{ cursor: 'pointer' }}
                                                            />
                                                        ) : (
                                                            <i
                                                                className="fa fa-eye-slash text-sm text-secondary"
                                                                onClick={
                                                                    this.togglePasswordVisibility
                                                                }
                                                                style={{ cursor: 'pointer' }}
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="grid sm:grid-cols-1">
                                                <label
                                                    htmlFor="select-subject"
                                                    className="block mb-2 text-base font-normal text-black mt-6 after:content-['*'] after:ml-0.5 after:text-red"
                                                >
                                                    Confirm Password
                                                </label>
                                                <div className="flex border-black-10 w-full rounded mb-2">
                                                    <div className="grow">
                                                        <input
                                                            type={
                                                                retypePasswordShown
                                                                    ? 'text'
                                                                    : 'password'
                                                            }
                                                            id="retypepassword"
                                                            value={this.state.retypepassword}
                                                            onChange={(evt) => {
                                                                this.setState({
                                                                    errormsg: '',
                                                                    retypepassword:
                                                                        evt.target.value,
                                                                });
                                                            }}
                                                            className="w-full py-1.5 text-black placeholder:text-secondary text-base px-2 rounded"
                                                            placeholder="Re-type Password"
                                                            autoComplete="off"
                                                            onKeyPress={(evt) => {
                                                                if (evt.key === ' ') {
                                                                    evt.preventDefault();
                                                                }
                                                            }}
                                                            maxLength={64}
                                                        />
                                                    </div>
                                                    <div className="flex items-center px-3">
                                                        {retypePasswordShown ? (
                                                            <i
                                                                className="fa-regular fa-eye text-sm text-secondary"
                                                                onClick={
                                                                    this
                                                                        .toggleRetypePasswordVisibility
                                                                }
                                                                style={{ cursor: 'pointer' }}
                                                            />
                                                        ) : (
                                                            <i
                                                                className="fa fa-eye-slash text-sm text-secondary"
                                                                onClick={
                                                                    this
                                                                        .toggleRetypePasswordVisibility
                                                                }
                                                                style={{ cursor: 'pointer' }}
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <button
                                                className="mt-4 text-white bg-primary rounded-lg font-semibold text-base px-3 py-1.5 sm:w-1/6 w-full"
                                                onClick={() => this.handleClick()}
                                                disabled={this.state.isdisable ? 'disabled' : null}
                                            >
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    {this.state.btnLoading ? (
                                                        <Spinner color="#FFF" />
                                                    ) : (
                                                        'Change'
                                                    )}
                                                </div>
                                            </button>
                                        </div>
                                        <div className="sm:col-span-1 col-span-12 mx-auto">
                                            <span
                                                className="xxl:ml-12 xxl:mr-12 md:ml-6 md:mr-6 h-full w-px line-bg hidden sm:block"
                                                aria-hidden="true"
                                            ></span>
                                        </div>
                                        <div className="sm:col-span-5 col-span-12">
                                            <p className="sm:mt-0 mt-4 mb-4">
                                                Password must contain
                                            </p>
                                            <div className="flex gap-2 flex-1 mb-1 sm:items-center items-start">
                                                {this.state.eightCharacter ? (
                                                    <>
                                                        <i
                                                            className="bi bi-check-circle"
                                                            style={{ color: 'green' }}
                                                        ></i>
                                                        <span className="text-green">
                                                            {' '}
                                                            Minimum of Eight characters
                                                        </span>
                                                    </>
                                                ) : (
                                                    <>
                                                        {' '}
                                                        <i className="far fa-times-circle"></i>
                                                        <span className="text-black ">
                                                            {' '}
                                                            Minimum of Eight characters
                                                        </span>
                                                    </>
                                                )}
                                            </div>
                                            <div className="flex gap-2 flex-1 mb-1 sm:items-center items-start">
                                                {this.state.oneUppercase ? (
                                                    <>
                                                        <i
                                                            className="bi bi-check-circle"
                                                            style={{ color: 'green' }}
                                                        ></i>
                                                        <span className="text-green">
                                                            {' '}
                                                            Atleast one uppercase
                                                        </span>
                                                    </>
                                                ) : (
                                                    <>
                                                        <i className="far fa-times-circle"></i>
                                                        <span className="text-black ">
                                                            {' '}
                                                            Atleast one uppercase
                                                        </span>
                                                    </>
                                                )}
                                            </div>
                                            <div className="flex gap-2 flex-1 mb-1 sm:items-center items-start">
                                                {this.state.oneLowercase ? (
                                                    <>
                                                        <i
                                                            className="bi bi-check-circle"
                                                            style={{ color: 'green' }}
                                                        ></i>
                                                        <span className="text-green">
                                                            {' '}
                                                            Atleast one lowercase
                                                        </span>
                                                    </>
                                                ) : (
                                                    <>
                                                        <i className="far fa-times-circle"></i>
                                                        <span className="text-black ">
                                                            {' '}
                                                            Atleast one lowercase
                                                        </span>
                                                    </>
                                                )}
                                            </div>
                                            <div className="flex gap-2 flex-1 mb-1 sm:items-center items-start">
                                                {this.state.oneNumberic ? (
                                                    <>
                                                        <i
                                                            className="bi bi-check-circle"
                                                            style={{ color: 'green' }}
                                                        ></i>
                                                        <span className="text-green">
                                                            {' '}
                                                            Atleast one numeric
                                                        </span>
                                                    </>
                                                ) : (
                                                    <>
                                                        <i className="far fa-times-circle"></i>
                                                        <span className="text-black ">
                                                            {' '}
                                                            Atleast one numeric
                                                        </span>
                                                    </>
                                                )}
                                            </div>
                                            <div className="flex gap-2 flex-1 mb-1 sm:items-center items-start">
                                                {this.state.specialCharacter ? (
                                                    <>
                                                        <i
                                                            className="bi bi-check-circle"
                                                            style={{ color: 'green' }}
                                                        ></i>
                                                        <span className="text-green">
                                                            {' '}
                                                            Atleast one special character
                                                        </span>
                                                    </>
                                                ) : (
                                                    <>
                                                        <i className="far fa-times-circle"></i>
                                                        <span className="text-black ">
                                                            {' '}
                                                            Atleast one special character
                                                        </span>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </main>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        changePassword: (valuse, callback) => {
            dispatch(changePassword(valuse, callback));
        },
        showNotification: (message, type) => {
            dispatch(showNotification(message, type));
        },
    };
};

export default connect(null, mapDispatchToProps)(ChangePassword);
